export default ['JsonRPCService', function (JsonRPCService) {
    return {
        checkConstructionCreditAllowed: function checkConstructionCreditAllowed(policyNumber) {
            return JsonRPCService.send('pc', 'gateway/policy', 'checkConstructionCreditAllowed', [policyNumber]);
        },
        //DEF-3054. This method is not used anywhere and seems replaced by the DTO property MSFRecentPayments_Ext
        /*getRecentPaymentForPolicy: (policyNumber) => {
            return JsonRPCService.send('bc', 'gatewaybilling/billingData', 'getRecentPaymentForPolicy', [policyNumber]);
        },*/
        getPolicy: function getPolicy(policyNumber) {
            return JsonRPCService.send('pc', 'gateway/policy', 'getPolicy', [policyNumber]);
        },
        getNotesForPolicy: function getNotesForPolicy(accountNumber) {
            return JsonRPCService.send('pc', 'gateway/policy', 'getNotesForPolicy', [accountNumber]);
        },
        createNoteForPolicy: function createNoteForPolicy(policyNumber, noteDTO) {
            return JsonRPCService.send('pc', 'gateway/policy', 'createNoteForPolicy', [policyNumber, noteDTO]);
        },
        callEUTS: function callEUTS(page, title, policyNo, event) {
            return JsonRPCService.send('pc', 'gateway/policy', 'callEUTS', [page, title, policyNo, event]);
        },
        checkLastReport: function checkLastReport(jobNumber) {
            return JsonRPCService.send('pc', 'policy/policy', 'checkLastReport', [jobNumber]);
        },
        submitPartTimePerCapitas: function submitPartTimePerCapitas(jobNumber, data, type, classPublicId) {
            return JsonRPCService.send('pc', 'policy/policy', 'submitPartTimePerCapitas', [jobNumber, data, type, classPublicId]);
        },
        getPartTimePerCapita: function getPartTimePerCapita(jobNumber, type) {
            return JsonRPCService.send('pc', 'policy/policy', 'getPartTimePerCapita', [jobNumber, type]);
        },
        submitFullTimePerCapita: function submitFullTimePerCapita(jobNumber, data, type, classPublicId) {
            return JsonRPCService.send('pc', 'policy/policy', 'submitFullTimePerCapita', [jobNumber, data, type, classPublicId]);
        },
        getFullTimePerCapita: function getFullTimePerCapita(jobNumber, type) {
            return JsonRPCService.send('pc', 'policy/policy', 'getFullTimePerCapita', [jobNumber, type]);
        },
        getDocumentsForPolicy: function getDocumentsForPolicy(policyNumber) {
            return JsonRPCService.send('pc', 'gateway/document', 'getDocumentsForPolicy', [policyNumber]);
        },
        uploadDoc: function uploadDoc(docDto) {
            return JsonRPCService.send('pc', 'gateway/policy', 'uploadFileDoc', [docDto]);
        },
        uploadForNewSubmission: function uploadForNewSubmission(docDto) {
            return JsonRPCService.send('pc', 'gateway/policy', 'uploadForNewSubmission', [docDto]);
        },
        getDocumentsByFileId: function getDocumentsByFileId(policyNumber, fileId) {
            return JsonRPCService.send('pc', 'gateway/document', 'getDocumentsByFileId', [policyNumber, fileId]);
        },
        getPolicyTransactionsForPolicy: function getPolicyTransactionsForPolicy(policyNumber) {
            return JsonRPCService.send('pc', 'gateway/policy', 'getPolicyTransactionsForPolicy', [policyNumber]);
        },
        checkConstructionCreditAdvance: function checkConstructionCreditAdvance(policyNumber, periodEffectiveDate, jobNumber) {
            return JsonRPCService.send('pc', 'gateway/policy', 'checkConstructionCreditAdvance', [policyNumber, periodEffectiveDate, jobNumber]);
        },
        getPotentialExistingAccounts: function getPotentialExistingAccounts(accountSearchCriteriaDTO) {
            return JsonRPCService.send('pc', 'gateway/policy', 'getPotentialExistingAccounts', [accountSearchCriteriaDTO]);
        },
        getLocationsForPolicy: function getLocationsForPolicy(policyNumber) {
            return JsonRPCService.send('pc', 'gateway/policy', 'getLocationsForPolicy', [policyNumber]);
        },
        locationChangeForPolicyChange: function locationChangeForPolicyChange(policyNumber, location, action) {
            return JsonRPCService.send('pc', 'gatewayquote/quote', 'locationChangeForPolicyChange', [policyNumber, location, action]);
        },
        editMailingAddressforPolicyChange_EXT: function editMailingAddressforPolicyChange_EXT(policyNumber, address) {
            return JsonRPCService.send('pc', 'gatewayquote/quote', 'editMailingAddressforPolicyChange_EXT', [policyNumber, address]);
        },
        createNewPolicyChangeTransaction: function createNewPolicyChangeTransaction(policyChange) {
            return JsonRPCService.send('pc', 'gateway/policy', 'createPolicyChangeTransaction', [policyChange]);
        },
        getElLimitOptions: function getElLimitOptions(jobNumber) {
            return JsonRPCService.send('pc', 'gateway/policy', 'getElLimitOptions', [jobNumber]);
        },
        updateConstructionCreditWages: function updateConstructionCreditWages(jobNumber, constructionCreditList) {
            return JsonRPCService.send('pc', 'gateway/policy', 'updateConstructionCreditWages', [jobNumber, constructionCreditList]);
        },
        createActivityForCCApplication: function createActivityForCCApplication(policyNumber) {
            return JsonRPCService.send('pc', 'gateway/policy', 'createActivityForCCApplication', [policyNumber]);
        },
        getConstructionCreditData: function getConstructionCreditData(jobNumber) {
            return JsonRPCService.send('pc', 'gateway/policy', 'getConstructionCreditData', [jobNumber]);
        },
        setConstructionCreditWages: function setConstructionCreditWages(jobNumber, constructionCreditList) {
            return JsonRPCService.send('pc', 'gateway/policy', 'setConstructionCreditWages', [jobNumber, constructionCreditList]);
        },
        setElLimitOption: function setElLimitOption(jobNumber, option) {
            return JsonRPCService.send('pc', 'gateway/policy', 'setElLimitOption', [jobNumber, option]);
        },
        quotePolicyChange: function quotePolicyChange(jobNumber) {
            return JsonRPCService.send('pc', 'gateway/policy', 'quotePolicyChange', [jobNumber]);
        },
        bindPolicyChange: function bindPolicyChange(jobNumber) {
            return JsonRPCService.send('pc', 'gateway/policy', 'bindPolicyChange', [jobNumber]);
        },
        quoteAndBindPolicyChange: function quoteAndBindPolicyChange(jobNumber) {
            return JsonRPCService.send('pc', 'gateway/policy', 'quoteAndBindPolicyChange', [jobNumber]);
        },
        submitSWOSForExistingCompany: function submitSWOSForExistingCompany(jobNumber, quote, MSFCOInsuranceDTO) {
            return JsonRPCService.send('pc', 'gateway/policy', 'submitSWOSForExistingCompany', [jobNumber, quote, MSFCOInsuranceDTO]);
        },
        getExistingWOS: function getExistingWOS(jobNumber) {
            return JsonRPCService.send('pc', 'gateway/policy', 'getExistingWOS', [jobNumber]);
        },
        getExistingSWOS: function getExistingSWOS(jobNumber) {
            return JsonRPCService.send('pc', 'gateway/policy', 'getExistingSWOS', [jobNumber]);
        },
        submitSWOSForNewCompany: function submitSWOSForNewCompany(jobNumber, quote, MSFCOInsuranceDTO) {
            return JsonRPCService.send('pc', 'gateway/policy', 'submitSWOSForNewCompany', [jobNumber, quote, MSFCOInsuranceDTO]);
        },
        createNewPolicyRenewalTransaction: function createNewPolicyRenewalTransaction(policyNumber) {
            return JsonRPCService.send('pc', 'gateway/policy', 'createPolicyRenewalTransaction', [policyNumber]);
        },
        createNewPolicyCancellationTransaction: function createNewPolicyCancellationTransaction(policyNumber, cancellation) {
            return JsonRPCService.send('pc', 'gateway/policy', 'createPolicyCancellationTransaction', [policyNumber, cancellation]);
        },
        createSubmitRequest: function createSubmitRequest(cancellation) {
            return JsonRPCService.send('pc', 'gateway/policy', 'createSubmitRequest', [cancellation]);
        },
        getRequestData: function getRequestData() {
            return JsonRPCService.send('pc', 'gateway/policy', 'getRequestData', []);
        },
        /* getWithdrawData: () => {
             return JsonRPCService.send('pc', 'gateway/policy', 'getWithdrawData', []);
         },*/
        getPolicyChangeOptions: function getPolicyChangeOptions() {
            return JsonRPCService.send('pc', 'gateway/policy', 'getPolicyChangeOptions', []);
        },
        getRequestDataForETStates: function getRequestDataForETStates() {
            return JsonRPCService.send('pc', 'gateway/policy', 'getRequestDataForETStates', []);
        },
        getOpenChangesForPolicy: function getOpenChangesForPolicy(policyNumber) {
            return JsonRPCService.send('pc', 'gateway/policy', 'getOpenChangesForPolicy', [policyNumber]);
        },
        checkMLEPolicy: function checkMLEPolicy(policyNumber) {
            return JsonRPCService.send('pc', 'gateway/policy', 'checkMLEPolicy', [policyNumber]);
        },
        withdrawPolicyTransaction: function withdrawPolicyTransaction(policyNumber, jobNumber) {
            return JsonRPCService.send('pc', 'gateway/policy', 'withdrawPolicyTransaction', [policyNumber, jobNumber]);
        },
        getEffectiveDateForPolicyChange: function getEffectiveDateForPolicyChange(policyNumber, effectiveDate) {
            return JsonRPCService.send('pc', 'gateway/policy', 'getEffectiveDateForPolicyChange', [policyNumber, effectiveDate]);
        },
        getPolicyBillingSummaryInfo: function getPolicyBillingSummaryInfo(policyNumber) {
            return JsonRPCService.send('pc', 'gateway/policy', 'getPolicyBillingSummaryInfo', [policyNumber]);
        },
        getPolicyClaims: function getPolicyClaims(policyNumber) {
            return JsonRPCService.send('pc', 'gateway/policy', 'getPolicyClaims', [policyNumber]);
        },
        addRecentlyViewedPolicy: function addRecentlyViewedPolicy(policyNumber) {
            return JsonRPCService.send('pc', 'gateway/policy', 'addRecentlyViewedPolicy', [policyNumber]);
        },
        getRecentlyViewedPolicies: function getRecentlyViewedPolicies() {
            return JsonRPCService.send('pc', 'gateway/policy', 'getRecentlyViewedPolicies', []);
        },
        getRecentlyIssuedPolicies: function getRecentlyIssuedPolicies(numberOfDays, queryOptions) {
            return JsonRPCService.send('pc', 'gateway/policy', 'getRecentlyIssuedPolicies', [numberOfDays, queryOptions]);
        },
        getPolicySummariesForCurrentUser: function getPolicySummariesForCurrentUser(numberOfDays, queryOptions) {
            return JsonRPCService.send('pc', 'gateway/policy', 'getPolicySummariesForCurrentUser', [numberOfDays, queryOptions]);
        },
        getPolicySummariesFromPolicyNumbers: function getPolicySummariesFromPolicyNumbers(policyNumbers) {
            return JsonRPCService.send('pc', 'gateway/policy', 'getPolicySummariesFromPolicyNumbers', [policyNumbers]);
        },
        getDisplayName: function getDisplayName() {
            return JsonRPCService.send('pc', 'gateway/policy', 'getDisplayName', []);
        },
        getScriptParameterString: function getScriptParameterString(parameterName) {
            return JsonRPCService.send('pc', 'gateway/policy', 'getScriptParameterString', [parameterName]);
        },
        findChangeJobByNumber: function findChangeJobByNumber(jobNumber) {
            return JsonRPCService.send('pc', 'gateway/policy', 'findChangeJobByNumber', [jobNumber]);
        },
        updateCoveredEmployees: function updateCoveredEmployees(jobNumber, portalcoveredEmployees, existingEmployees) {
            return JsonRPCService.send('pc', 'gateway/policy', 'updateJobCoveredEmployees', [jobNumber, portalcoveredEmployees, existingEmployees]);
        },
        getPerCapitaCodesByPolicyNumber: function getPerCapitaCodesByPolicyNumber(policyNumber) {
            return JsonRPCService.send('pc', 'gateway/policy', 'getPerCapitaCodesByPolicyNumber', [policyNumber]);
        },
        getPerCapitaCodesByJobNumber: function getPerCapitaCodesByJobNumber(jobNumber) {
            return JsonRPCService.send('pc', 'gateway/policy', 'getPerCapitaCodesByJobNumber', [jobNumber]);
        },
        getEmodValues: function getEmodValues(riskNumber, emodNum, emodTypeCode, newDate) {
            return JsonRPCService.send('pc', 'gateway/policy', 'getEmodValues', [riskNumber, emodNum, emodTypeCode, newDate]);
        },
        isValidRiskID: function isValidRiskID(riskid) {
            return JsonRPCService.send('pc', 'gateway/policy', 'isValidRiskID', [riskid]);
        },
        getCurrentDate: function getCurrentDate() {
            return JsonRPCService.send('pc', 'gateway/policy', 'getCurrentDate');
        },
        getMsfPortalHost: function getMsfPortalHost() {
            return JsonRPCService.send('pc', 'gateway/policy', 'getMsfPortalHost');
        },
        getAccountPolicyDetails: function getAccountPolicyDetails(policyNumber) {
            return JsonRPCService.send('pc', 'gateway/policy', 'getAccountPolicyDetails', [policyNumber]);
        },
        createActivityForLocationChange: function createActivityForLocationChange(policyNumber, oldAddress, newAddress) {
            return JsonRPCService.send('pc', 'gateway/policy', 'createActivityForLocationChange', [policyNumber, oldAddress, newAddress]);
        },
        createActivityForMailingAddressChange: function createActivityForMailingAddressChange(policyNumber, oldAddress, newAddress) {
            return JsonRPCService.send('pc', 'gateway/policy', 'createActivityForMailingAddressChange', [policyNumber, oldAddress, newAddress]);
        },
        createActivityForPolicyChangeOptions: function createActivityForPolicyChangeOptions(jobNumber, policyNumber, oldValue, newValue, policyChangeType, companyName, effectiveDate, newClassCodeList, editedClassCodeList) {
            return JsonRPCService.send('pc', 'gateway/policy', 'createActivityForPolicyChangeOptions', [jobNumber, policyNumber, oldValue, newValue, policyChangeType, companyName, effectiveDate, newClassCodeList, editedClassCodeList]);
        },
        createActivityForPortalChanges: function createActivityForPortalChanges(policyNumber, periodStart, periodEnd, actionType, reason, description) {
            return JsonRPCService.send('pc', 'gateway/policy', 'createActivityForPortalChanges', [policyNumber, periodStart, periodEnd, actionType, reason, description]);
        },
        checkPcAvailability: function checkPcAvailability() {
            return JsonRPCService.send('pc', 'gateway/policy', 'checkPcAvailability');
        },
        checkCanRemoveLocation: function checkCanRemoveLocation(policyNumber, locationId) {
            return JsonRPCService.send('pc', 'gateway/policy', 'canRemoveLocation', [policyNumber, locationId]);
        },
        getRenewalPeriodData: function getRenewalPeriodData(policyNumber) {
            return JsonRPCService.send('pc', 'gateway/policy', 'getRenewalPeriodData', [policyNumber]);
        },
        createCustomHistoryEvent: function createCustomHistoryEvent(jobNumber, customHistoryCode) {
            return JsonRPCService.send('pc', 'gateway/policy', 'createCustomHistoryEvent', [jobNumber, customHistoryCode]);
        },
        searchWCCoveredEmployees_Ext: function searchWCCoveredEmployees_Ext(policyNumber, searchCriteria, offset) {
            return JsonRPCService.send('pc', 'gateway/policy', 'searchWCCoveredEmployees_Ext', [policyNumber, searchCriteria, offset]);
        }
    };
}];


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/gateway/services/PolicyService.js
// module id = 1791
// module chunks = 0